import React from 'react';
import classnames from 'classnames';

import Link from './renderers/Link';

const Button = ({
  block = false,
  children,
  className,
  colour = 'grey',
  disabled = false,
  href,
  hover,
  onClick,
  size = 'regular',
  appearance = 'regular',
  ...rest
}) => {
  const hoverColour = hover || colour;

  const hoverClass = {
    regular: {
      dark: 'hover:bg-transparent hover:text-haiti',
      grey: 'hover:bg-transparent',
      pink: 'hover:bg-rose hover:text-white',
      purple: 'hover:bg-cornflower hover:text-white',
      white: 'hover:bg-white hover:text-haiti',
      blue: 'hover:bg-transparent hover:text-deep-koamaru',
      royal: 'hover:bg-transparent hover:text-royal-blue',
      rose: 'hover:bg-transparent hover:text-rose',
    },
    minimal: {
      dark: '',
      grey: '',
      pink: '',
      purple: '',
      white: '',
      blue: '',
      blue: '',
      royal: '',
      rose: '',
    },
    outline: {
      dark: 'hover:bg-haiti hover:text-white',
      grey: 'hover:bg-primary-100',
      pink: 'hover:bg-rose hover:text-white',
      purple: 'hover:bg-cornflower hover:text-white',
      white: '',
      blue: 'hover:bg-deep-koamaru hover:text-white',
      royal: 'hover:bg-royal-blue hover:text-white',
    },
  };

  const styleClass = {
    regular: {
      dark: 'bg-haiti border-haiti text-white',
      grey: 'bg-primary-100 border-primary-100 text-haiti',
      pink: 'bg-rose border-rose text-white',
      purple: 'bg-cornflower border-cornflower text-white',
      white: 'bg-white border-white text-haiti',
      blue: 'bg-deep-koamaru border-deep-koamaru text-white',
      royal: 'bg-royal-blue border-royal-blue text-white',
    },
    minimal: {
      dark: 'bg-transparent border-transparent text-haiti',
      grey: 'bg-transparent border-transparent text-primary-100',
      pink: 'bg-transparent border-transparent text-rose',
      purple: 'bg-transparent border-transparent text-cornflower',
      white: 'bg-transparent border-transparent text-white',
      blue: 'bg-transparent border-transparent text-deep-koamaru',
      royal: 'bg-transparent border-transparent text-royal-blue',
    },
    outline: {
      dark: 'bg-transparent border-haiti text-haiti',
      grey: 'bg-transparent border-primary-100 text-haiti',
      pink: 'bg-transparent border-rose text-rose',
      purple: 'bg-transparent border-cornflower text-cornflower',
      white: 'bg-transparent border-white text-white',
      blue: 'bg-transparent border-deep-koamaru text-deep-koamaru',
      royal: 'bg-transparent border-royal-blue text-royal-blue',
    },
  };

  const appearanceVal = (appearance) => {
    switch (appearance) {
      case 'minimal':
      case 'outline':
      case 'regular':
        return appearance;
      default:
        return 'regular';
    }
  };

  const colourVal = (colour) => {
    switch (colour) {
      case 'dark':
      case 'grey':
      case 'pink':
      case 'purple':
      case 'white':
      case 'blue':
      case 'royal':
        return colour;
      default:
        return 'grey';
    }
  };

  const sizeClass = (size) => {
    switch (size) {
      case 'small':
        return 'px-2 py-1 text-xs md:text-sm';
      case 'large':
        return 'px-6 py-2';
      case 'regular':
      default:
        return 'px-4 py-2 text-sm';
    }
  };

  const buttonClass = classnames(
    'border font-semibold inline-block rounded text-center',
    sizeClass(size),
    styleClass[appearanceVal(appearance)][colourVal(colour)],
    hoverClass[appearanceVal(appearance)][colourVal(hoverColour)],
    className,
    {
      'cursor-not-allowed opacity-50': disabled,
      'w-full': block,
    }
  );

  if (href) {
    return (
      <Link href={href} className={buttonClass} onClick={onClick}>
        {children}
      </Link>
    );
  }

  return (
    <button
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
      type="submit"
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
